var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"equipment"},[_c('PageTopNav',{attrs:{"tabsShow3":true,"tabList3":_vm.tabList3,"isAi":"","isAi2":"","changeIndex3":_vm.changeIndex3},on:{"changeTab3":_vm.changeTab3}}),_c('router-view'),_c('MyNav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }